module.exports = __webpack_public_path__ + "img/estrella.f42cb4e4.svg";